<template>
  <v-row>
    <v-overlay
      absolute
      v-if="$store.getters.userIs('employee')"
      :value="true"
    >
      <div class="title white--text">This Section is Disabled For Employees</div>
    </v-overlay>

    <transition name="fade-up" mode="out-in" appear>
      <v-col v-if="loading" class="text-center" key="loader">
        <v-progress-circular
          :size="40"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-col>
      <v-col v-else cols="12" key="billingPlanChooser">
        <div class="title mb-1 text-center">Choose A Plan</div>
        <v-container fluid>
          <v-row class="justify-center">
            <v-col cols="3" v-if="agentPricing">
              <v-card>
                <v-card-text>
                  <div class="billingPlanTitle mb-2">{{ agentPricing.title }}</div>
                  <div class="billingPlanImage mb-2">
                    <v-img v-if="agentPricing.image" :src="agentPricing.image" contain style="max-height: 100px;" />
                  </div>
                  <div class="billingPlanDescription"> {{ agentPricing.description }}</div>
                  <v-row no-gutters class="justify-center mt-3">
                    <v-col cols="12" v-if="user.subscription_status == 'ACTIVE'">
                      <v-row no-gutters>
                        <v-col cols="12" class="text-center">
                          <div class="title success--text">
                            <v-icon large class="success--text">mdi-check-circle</v-icon>
                            Active
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <v-btn color="grey lighten-1" text x-small @click="cancelSubscription('agent')">Cancel</v-btn>
                        </v-col>
                        <v-col cols="6" class="text-right">
                          <div class="caption grey--text text--lighten-1">{{ user.card_desc | stripeCard }}</div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6" v-else-if="agentPricing.monthly >= 0" class="text-center">
                      <div class="title">{{ agentPricing.monthly | currencyRounded }} / month</div>
                      <v-btn color="primary" block class="mt-2" @click="newSubscription('agent_monthly')" :loading="agentSubscribing" :disabled="partnerSubscribing" >Subscribe Now</v-btn>
                    </v-col>
                    <!--<v-col cols="6" v-if="agentPricing.yearly" class="text-center">
                      <div class="overline">Yearly</div>
                      <v-btn color="primary" block>{{ agentPricing.yearly | currencyRounded }}</v-btn>
                    </v-col>-->
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="3" v-if="showPartnerPricing">
              <v-card>
                <v-card-text>
                  <div class="billingPlanTitle mb-2">{{ partnerPricing.title }}</div>
                  <div v-if="partnerPricing.image" class="billingPlanImage mb-2">
                    <v-img :src="partnerPricing.image" contain style="max-height: 100px;" />
                  </div>
                  <div class="billingPlanDescription"> {{ partnerPricing.description }}</div>
                  <v-row no-gutters class="justify-center mt-3">
                    <v-col cols="12" v-if="user.partnership.subscription_status == 'ACTIVE'">
                      <v-row no-gutters>
                        <v-col cols="12" class="text-center">
                          <div class="title success--text">
                            <v-icon large class="success--text">mdi-check-circle</v-icon>
                            Active
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <v-btn color="grey lighten-1" text x-small @click="cancelSubscription('partner')">Cancel</v-btn>
                        </v-col>
                        <v-col cols="6" class="text-right">
                          <div class="caption grey--text text--lighten-1">{{ user.partnership.card_desc | stripeCard }}</div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6" v-else-if="partnerPricing.monthly" class="text-center">
                      <div class="title">{{ partnerPricing.monthly | currencyRounded }} / month</div>
                      <v-btn color="primary" block class="mt-2" @click="newSubscription('partner_monthly')" :loading="partnerSubscribing" :disabled="agentSubscribing" >Subscribe Now</v-btn>
                    </v-col>
                    <!--<v-col cols="6" v-if="agentPricing.yearly" class="text-center">
                      <div class="overline">Yearly</div>
                      <v-btn color="primary" block>{{ agentPricing.yearly | currencyRounded }}</v-btn>
                    </v-col>-->
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </transition>
  </v-row>
</template>

<script>
export default {
  name: 'BillingIndex',
  data () {
    return {
      loading: true,
      agentSubscribing: false,
      partnerSubscribing: false,
      plans: {}
    }
  },
  mounted() {
    this.getDataFromApi()
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    agentPricing () {
      let pricing = {
        title:          '',
        description:    '',
        image:          '',
        monthly:        null,
        yearly:         null,
        yearlySavings:  0
      }

      let yearly      = this.plans.stripe_agent_price_yearly
      let monthly     = this.plans.stripe_agent_price_monthly
      /*if(yearly) {
        pricing.title           = yearly.name,
        pricing.description     = yearly.description,
        pricing.image           = yearly.image
        pricing.yearly          = (yearly.amount / 100)
      }*/
      if(monthly) {
        pricing.title           = monthly.name,
        pricing.description     = monthly.description,
        pricing.image           = monthly.image
        pricing.monthly         = (monthly.amount / 100)
      }

      if(pricing.monthly && pricing.yearly) {
        let savings               = yearly.amount - (monthly.amount * 12)
        pricing.yearlySavings     = (savings / 100)
      }

      return pricing
    },

    partnerPricing () {
      let pricing = {
        title:          '',
        description:    '',
        image:          '',
        monthly:        null,
        yearly:         null,
        yearlySavings:  0
      }

      let yearly      = this.plans.stripe_partner_price_yearly
      let monthly     = this.plans.stripe_partner_price_monthly
      /*if(yearly) {
        pricing.title           = yearly.name,
        pricing.description     = yearly.description,
        pricing.image           = yearly.image
        pricing.yearly          = (yearly.amount / 100)
      }*/
      if(monthly) {
        pricing.title           = monthly.name,
        pricing.description     = monthly.description,
        pricing.image           = monthly.image
        pricing.monthly         = (monthly.amount / 100)
      }

      if(pricing.monthly && pricing.yearly) {
        let savings               = yearly.amount - (monthly.amount * 12)
        pricing.yearlySavings     = (savings / 100)
      }

      return pricing
    },
    showPartnerPricing () {
      if(!this.partnerPricing) return false
      if(!this.$store.getters.user.partnership) return false
      if(!this.$store.getters.userIs('partnershipAdmin')) return false
      return true
    },
    partnerSubscriptionStatus () {
      if(this.$store.getters.user.partnership) return this.$store.getters.user.partnership.subscription_status
      return 'INACTIVE'
    }
  },
  methods: {
    getDataFromApi() {
      this.loading = true

      this.$http.get('config/current-stripe-pricing')
        .then(response => {
          this.plans    = response.data
          if(!this.$store.getters.canAccessProduct) {
            this.newSubscription('agent_monthly')
          } else {
            this.loading  = false
          }
        })
        .catch(() => {
          this.$swal.fire('Error', 'There was an error loading billing plans. Please try again.', 'error')
        })
    },
    newSubscription(subscription) {
      if(subscription == 'agent_monthly') this.agentSubscribing = true
      if(subscription == 'partner_monthly') this.partnerSubscribing = true
      let params = {
        plan: subscription
      }

      this.$http.post('users/' + this.user.id + '/checkout-session', params)
        .then(response => {
          let session_id = response.data.session.id
          let stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)
          let ref = this
          stripe.redirectToCheckout({
            sessionId: session_id
          }).then(function (result) {
            this.$swal.fire('Error', 'There was an error connecting to Stripe. Please try again.', 'error')
            console.log(result.error.message)
            ref.agentSubscribing = false
            ref.partnerSubscribing = false
          })
        })
        .catch(() => {
          this.$swal.fire('Error', 'There was an error connecting to Stripe. Please try again.', 'error')
        })
    },
    cancelSubscription(subscription) {
      this.$swal.fire({
        title: 'Cancel Subscription?',
        html: 'Are you sure you want to cancel your subscription? You will no longer be able to access any products or data on the platform',
        confirmText: 'Yes',
        cancelText: 'No',
        focusCancel: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.$http.post('users/' + this.user.id + '/cancel-subscription', {plan: subscription})
            .then(() => {
              this.$store.dispatch('checkForUpdates', true)
              return true
            })
            .catch(() => {
              this.$swal.fire('Error', 'There was an error cancelling your subscription. Please try again. If the problem persists please contact support', 'error');
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .billingPlanTitle {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    height: 50px;
    max-height: 50px;
    min-height: 50px;
  }
  .billingPlanDescription {
    height: 140px;
    max-height: 140px;
    min-height: 140px;
  }
  .billingPlanImage {
    height: 110px;
    max-height: 110px;
    min-height: 110px;
  }
</style>